import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FAF5EE] hex-pattern flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-white rounded-2xl border border-[#E6D7C3] p-10 text-center shadow-xl">
        <div className="flex justify-center mb-6"><Logo size={48} /></div>
        <h1 className="font-serif-display text-2xl font-bold text-[#2C221E]" data-testid="cancel-heading">No harm done</h1>
        <p className="mt-3 text-sm text-[#5A4D44] leading-relaxed">
          Your checkout was cancelled and nothing was charged. Your basket is saved — come back whenever you're ready.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-home-link"
          className="mt-8 inline-block px-8 py-3 rounded-full bg-[#2C221E] hover:bg-[#D97706] text-[#FAF5EE] font-semibold text-sm transition-colors"
        >
          Back to the Shop
        </Link>
      </div>
    </div>
  );
}
